import { defaultSetClass } from './defaultSetClass';
export var defaultSetHTMLClass = function defaultSetHTMLClass(property, value) {
  defaultSetClass(document.documentElement, property, value);
};